// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YAa3W","col":"styles_col__1KuCh"};